import { createSlice } from '@reduxjs/toolkit';
import { ToastSettings } from '@components';

interface NotificationState {
  toastSettings: ToastSettings;
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    value: {
      toastSettings: {
        message: undefined,
        show: false,
        type: undefined,
      },
    } as NotificationState,
  },
  reducers: {
    setToastSettings: (state, action: { type: string; payload: ToastSettings }) => {
      state.value.toastSettings = action.payload;
    },
    showToast: (state, action: { type: string; payload: { message: string; type: 'success' | 'error' } }) => {
      state.value.toastSettings = {
        message: action.payload.message,
        show: true,
        type: action.payload.type,
      };
    },
  },
});

export const { setToastSettings, showToast } = notificationSlice.actions;

export default notificationSlice.reducer;
